import { render, staticRenderFns } from "./ProductUpsellCheckbox.vue?vue&type=template&id=31783f1a"
import script from "./ProductUpsellCheckbox.vue?vue&type=script&lang=js"
export * from "./ProductUpsellCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports